import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import api from '../services/api';

export default function ResetarSenha() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token');

  const [senha, setSenha] = useState('');
  const [confirma, setConfirma] = useState('');
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState(false);

  useEffect(() => {
    if (!token) setErro('Token inválido. Solicite um novo link.');
  }, [token]);

  const enviar = async (e) => {
    e.preventDefault();
    setErro('');
    if (senha.length < 6) return setErro('Senha deve ter no mínimo 6 caracteres');
    if (senha !== confirma) return setErro('As senhas não coincidem');

    setLoading(true);
    try {
      await api.post('/auth/resetar-senha', { token, senha });
      setSucesso(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao alterar senha');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, background: 'var(--bg)' }}>
      <div style={{ maxWidth: 400, width: '100%', background: 'var(--bg2)', padding: 30, borderRadius: 12, border: '1px solid var(--border)' }}>
        <h2 style={{ color: 'var(--orange)', marginTop: 0, textAlign: 'center' }}>🔑 Nova Senha</h2>

        {sucesso ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 64, marginBottom: 10 }}>✅</div>
            <h3 style={{ color: '#2ea82e' }}>Senha alterada!</h3>
            <p style={{ color: 'var(--text2)', fontSize: 14 }}>
              Redirecionando para o login...
            </p>
          </div>
        ) : (
          <>
            <p style={{ color: 'var(--text2)', fontSize: 14, textAlign: 'center', marginBottom: 20 }}>
              Digite sua nova senha abaixo.
            </p>
            <form onSubmit={enviar}>
              <input
                type="password"
                className="input-field"
                placeholder="Nova senha (mín. 6 caracteres)"
                value={senha}
                onChange={e => setSenha(e.target.value)}
                required
                minLength={6}
                style={{ width: '100%', marginBottom: 12, boxSizing: 'border-box' }}
              />
              <input
                type="password"
                className="input-field"
                placeholder="Confirme a nova senha"
                value={confirma}
                onChange={e => setConfirma(e.target.value)}
                required
                minLength={6}
                style={{ width: '100%', marginBottom: 12, boxSizing: 'border-box' }}
              />
              {erro && <div style={{ color: '#e55', fontSize: 13, marginBottom: 12, textAlign: 'center' }}>⚠️ {erro}</div>}
              <button type="submit" disabled={loading || !token} style={{
                width: '100%', background: 'linear-gradient(135deg, var(--red), var(--orange))',
                color: '#fff', border: 'none', padding: 14, borderRadius: 8,
                fontSize: 15, fontWeight: 700, cursor: 'pointer', opacity: (loading || !token) ? 0.6 : 1
              }}>
                {loading ? 'Alterando...' : '💾 Alterar senha'}
              </button>
            </form>
          </>
        )}

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <Link to="/login" style={{ color: 'var(--orange)', fontSize: 13, textDecoration: 'none' }}>
            ← Voltar para o login
          </Link>
        </div>
      </div>
    </div>
  );
}
